import LogData from './view'

export default LogData
export {
  LogData
}